import React from "react";
import {IconButton, Typography} from "@mui/material";
import {AddCircle as AddIcon} from "@mui/icons-material";

const InlineAdd = (props) => {
    const {label, onClick} = props;

    return <div className="inline-add">
        <IconButton
            title="Add"
            color="primary"
            variant="text"
            onClick={onClick}
        >
            <AddIcon/>
        </IconButton>
        <Typography
            className="item"
            variant="caption"
            color="text.primary"
        >
            Add {label}
        </Typography>
    </div>
};

export default InlineAdd;
